export default __webpack_public_path__ + "static/media/Maize.dcff98d2.jpg";